import React, { useState } from 'react';
import './SeoulJuicePage.css';
import SeoulJuiceIcon from '../images/SeoulJuiceIcon.png';
import SJ_Logo from '../images/SJ_Logo.png';
import img1 from '../images/SJimg1.png';
import img2 from '../images/SJimg2.png';
import img3 from '../images/SJimg3.png';
import img4 from '../images/SJimg4.png';
import img5 from '../images/SJimg5.png';
import img6 from '../images/SJimg6.png';
import img7 from '../images/SJimg7.png';
import img8 from '../images/SJimg8.png';
import benefitImg1 from '../images/SJbenefitimg1.png';
import benefitImg2 from '../images/SJbenefitimg2.png';
import benefitImg3 from '../images/SJbenefitimg3.png';
import benefitImg4 from '../images/SJbenefitimg4.png';
import aboutImg1 from '../images/SJaboutimg1.png';
import aboutImg2 from '../images/SJaboutimg2.png';
import aboutImg3 from '../images/SJaboutimg3.png';
import aboutImg4 from '../images/SJaboutimg4.png';
import SFImg1 from '../images/SJ_SFimg1.png';
import SJmerchimg1 from '../images/SJmerchimg1.png';

const rolls = {
  SJ_Logo: [img1, img2, img3, img4, img5, img6, img7, img8],
  Benefits: [benefitImg1, benefitImg2, benefitImg3, benefitImg4],
  About: [aboutImg1, aboutImg2, aboutImg3, aboutImg4],
  WheretoFind: [SFImg1],
  Buy: [img5],
  Merch: [SJmerchimg1],
};

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;1,400;1,500&family=DM+Sans:wght@300;400;500&display=swap');

  :root {
    --ink:      #1A1814;
    --ink-2:    #4A4740;
    --ink-3:    #8A8780;
    --rule:     rgba(26,24,20,0.10);
    --rule-md:  rgba(26,24,20,0.18);
    --sand:     #F7F4EE;
    --white:    #FFFFFF;
    --red:      #BA2504;
    --red-lt:   #FAF0EE;
    --serif:    'Cormorant Garamond', Georgia, serif;
    --sans:     'DM Sans', system-ui, sans-serif;
  }

  /* ── HERO ─────────────────────────────────────────────────────────────────── */
  .sj-hero {
    background: #f4bc0d;
    padding: 80px 48px 72px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 40px;
  }

  .sj-hero-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .sj-hero-eyebrow {
    display: none;
  }

  .sj-hero-title {
    font-family: var(--serif);
    font-size: 56px;
    font-weight: 400;
    color: var(--white);
    line-height: 1;
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .sj-hero-icon {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    object-fit: contain;
    background: rgba(255,255,255,0.15);
    padding: 6px;
    flex-shrink: 0;
  }

  /* ── BODY ─────────────────────────────────────────────────────────────────── */
  .sj-body {
    max-width: 800px;
    margin: 0 auto;
    padding: 64px 48px 72px;
    border-bottom: 0.5px solid var(--rule);
  }

  .sj-body p {
    font-family: var(--sans);
    font-size: 17px;
    font-weight: 400;
    line-height: 1.85;
    color: var(--ink);
    margin-bottom: 28px;
  }

  .sj-body p:last-child { margin-bottom: 0; }

  /* ── WEBSITE SECTION ──────────────────────────────────────────────────────── */
  .sj-website-label {
    padding: 32px 48px 0;
    font-family: var(--sans);
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--ink-3);
    text-align: center;
  }

  /* ── PRESERVED ORIGINAL STYLES ────────────────────────────────────────────── */
  .sj-content-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 20px 40px;
  }

  .sj-logo {
    width: 250px;
    height: 65px;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .sj-headings {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    font-family: 'Merriweather', serif;
  }

  .sj-headings h2 {
    font-size: 15px;
    cursor: pointer;
    color: #0b0b0b;
    padding-left: 15px;
    padding-right: 15px;
  }

  .sj-headings h2:hover { text-decoration: underline; }

  .sj-roll {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .sj-roll-image {
    height: 500px;
    width: 1200px;
  }

  /* ── RESPONSIVE ──────────────────────────────────────────────────────────── */
  @media (max-width: 900px) {
    .sj-hero { padding: 56px 24px 48px; flex-direction: column; align-items: flex-start; }
    .sj-hero-title { font-size: 40px; }
    .sj-body { padding: 48px 24px; }
    .sj-website-label { padding: 24px 24px 0; }
  }
`;

function SeoulJuicePage() {
  const [activeRoll, setActiveRoll] = useState('SJ_Logo');

  return (
    <div>
      <style>{styles}</style>

      {/* ── HERO ── */}
      <div className="sj-hero">
        <div className="sj-hero-left">
          <img src={SeoulJuiceIcon} alt="Seoul Juice" className="sj-hero-icon" />
          <span className="sj-hero-title">Seoul Juice</span>
        </div>
      </div>

      {/* ── BODY ── */}
      <div className="sj-body">
        <p>Seoul Juice was started by my brother in 2014, back when he was a college athlete who had an allergic reaction to the dyes in popular sports drinks and decided to make something better himself. I was always doing anything I could to help, which included being the first guinea pig, tasting a vast array of powder and puree mixes in the early days. A few years later that turned into helping with the website. I taught myself Wix, heavily researched competitor sites, and put together a first prototype.</p>

        <p>In January 2023 I joined officially, part-time. The brand had real traction in retail but online was lagging. I had no ecommerce experience coming in. I learned it all on the fly, studying what the top performers on Amazon were doing, reverse engineering their listings, and applying what I found to ours. Same approach with the site and ads. I'd make multiple versions, test them, look at what the data said, cut what wasn't working, iterate on what was, and keep going. I redesigned the site and moved it to Shopify, managed the Amazon listing, and worked with the social media team across Instagram, Facebook, and TikTok. By the end of my time there online sales had grown 83%.</p>

        <p>The company has since been sold. Below is a replica of the 2023 website I built. It's not fully functional, no live cart or dynamic content, but it shows the layout, navigation, and design work.</p>
      </div>

      {/* ── WEBSITE REPLICA ── */}
      <p className="sj-website-label">2023 website replica</p>
      <div className="sj-content-section">
        <img
          src={SJ_Logo}
          alt="Seoul Juice"
          className="sj-logo"
          onClick={() => setActiveRoll('SJ_Logo')}
        />
        <div className="sj-headings">
          <h2 onClick={() => setActiveRoll('Buy')}>Buy</h2>
          <h2 onClick={() => setActiveRoll('Benefits')}>Benefits</h2>
          <h2 onClick={() => setActiveRoll('WheretoFind')}>Where to Find</h2>
          <h2 onClick={() => setActiveRoll('About')}>About</h2>
          <h2 onClick={() => setActiveRoll('Merch')}>Merch</h2>
        </div>
        <div className="sj-roll">
          {rolls[activeRoll].map((image, index) => (
            <img key={index} src={image} alt={`${activeRoll} ${index + 1}`} className="sj-roll-image" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default SeoulJuicePage;
